import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LocaleString } from '../translate/localeString.model';

import { LocalizePipe } from './localize.pipe';


@Pipe({
    name: 'localizeORtranslate',
    pure: false,
    standalone: false
})
export class LocalizeOrTranslatePipe implements PipeTransform {

    constructor(
        private localize: LocalizePipe,
        private translate: TranslocoService,
    ) { }

    transform(value: LocaleString|string): string {
        if (typeof(value) === 'string') {
            return this.translate.translate(value);
        } else {
            return this.localize.transform(value);
        }
    }

}
